import { selectExternalInfos } from '@/domain/external/external.selectors';
import { useAppSelector } from '@/ui/hook/store';

import { FinishMessage } from './FinishMessage';
import { Layout } from './Layout';

export function Step3Done() {
  const infos = useAppSelector(selectExternalInfos);
  return (
    <Layout userName={infos.userName}>
      <FinishMessage />
    </Layout>
  );
}
